import GameIds from '../../hub/data/GameIds';

export const GAME_ID = GameIds.MESSAGE_IN_A_BOTTLE;

export const LEVEL_MASTERY_THRESHOLD = 0.8;

export const ITEMS_COUNT_IN_PRACTICE = 2;
export const ITEMS_COUNT_IN_ROUND = 5;

export const NUM_FAILED_ITEMS_BEFORE_PRACTICE = 2;

export const SCREENS = {
  LOADING: 'LOADING',
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
};

export const REDUX_ACTIONS = {
  SET_ALEX_STATE: 'SET_ALEX_STATE',
  BEGIN_ROUND: 'BEGIN_ROUND',
  COMPLETE_ITEM: 'COMPLETE_ITEM',
  CHOOSE_NEXT_SENTENCE: 'CHOOSE_NEXT_SENTENCE',
  COMPLETE_ROUND: 'COMPLETE_ROUND',
  UPDATE_PRACTICE_DETAILS: 'UPDATE_PRACTICE_DETAILS',
  SET_HAS_DONE_ONBOARDING: 'SET_HAS_DONE_ONBOARDING',
  CLEAR_PROGRESS: 'CLEAR_PROGRESS',
  QUICK_ROUND: 'QUICK_ROUND',
  SET_SENTENCE_ZONE_BORDER: 'SET_SENTENCE_ZONE_BORDER',
  SET_DONE_BUTTON_STATE: 'SET_DONE_BUTTON_STATE',
  SET_USING_PRACTICE_ASSETS: 'SET_USING_PRACTICE_ASSETS',
  SET_SENTENCE_ZONE_POSITION: 'SET_SENTENCE_ZONE_POSITION',
  NEW_ITEM: 'NEW_ITEM',
  CHECK_FOR_CORRECT: 'CHECK_FOR_CORRECT',
  ATTACH_ADJACENT_WORDS: 'ATTACH_ADJACENT_WORDS',
  SET_TRACKER_WIDTH: 'SET_TRACKER_WIDTH',
  SET_TRACKER_ORDER: 'SET_TRACKER_ORDER',
  SET_BEING_DRAGGED: 'SET_BEING_DRAGGED',
  SET_IS_DRAGGABLE: 'SET_IS_DRAGGABLE',
  DRAG_MOVE: 'DRAG_MOVE',
};
